/** "Why we're different" / objection handling: copy deck §5. */
import { Section, SectionHeading } from './Section.js';

const CARDS = [
  {
    q: 'Isn’t cold email just spam?',
    a: 'Spam is irrelevant email blasted at people who never wanted it, with no way out. Cold email done right is a targeted, compliant message to a specific person who could genuinely use what you sell, with a one-click unsubscribe in every send. RevBase is built for the second kind and actively makes the first kind hard: suppression lists, required opt-out, and auto-pause when complaints rise. If you want to spray, you’ll hate this tool. Good.',
  },
  {
    q: 'Won’t this burn my domain?',
    a: 'That’s the failure mode RevBase was designed to prevent. New mailboxes ramp slowly. Volume is capped per inbox. Warmup runs before you send cold. SPF/DKIM/DMARC get checked up front. And if bounces or complaints spike, RevBase pauses the campaign automatically before your reputation takes the hit. Every other tool lets you floor it. RevBase has brakes, and uses them.',
  },
];

export function Objections() {
  return (
    <Section>
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="Objections"
            title="Yes, cold email gets a bad rap. We earned the opposite."
            lead={<>Let&rsquo;s address the two things every honest buyer is thinking.</>}
          />
        </div>
        <div className="space-y-4 lg:col-span-8">
          {CARDS.map((card) => (
            <div key={card.q} className="card p-6 sm:p-8">
              <div className="font-display text-lg font-semibold text-slate-900 sm:text-xl">
                {card.q}
              </div>
              <p className="mt-3 leading-relaxed text-slate-600">{card.a}</p>
            </div>
          ))}
        </div>
      </div>
      <p className="mx-auto mt-14 max-w-3xl border-l-2 border-brand-700 pl-5 font-display text-2xl font-bold leading-snug text-slate-900">
        The other tools optimize for how much you can send. RevBase optimizes for
        how long you can keep sending.
      </p>
    </Section>
  );
}
